import React, { useState, useEffect } from "react";
import "./selectLocation.css";

import { motion } from "framer-motion";

import LocationList from "./components/LocationList";
import MapLogo from "./components/MapLogo";

import Map from "./components/Map";

import { useShipping } from "../../contexts/ShippingContext";

import Locations from "../../data/locations.json";

import ConfirmLocation from "./components/ConfirmLocation";
import { Navigate } from "react-router-dom";

export default function SelectLocation() {
  const [allLocations, setAllLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState();

  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShowMap(true), 7000);

    return () => clearTimeout(timeout);
  }, []);

  const { allowLocation, isFetching } = useShipping();

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/client/deliver-locations/", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((d) => setAllLocations(d.data));
  }, []);
  if (!isFetching() && !allowLocation()) return <Navigate to="/" replace />;

  function handleSelect(_, id) {
    setSelectedLocationId(id);
  }

  function handleErase() {
    setSelectedLocationId(null);
  }

  const getSelectedLocation = () =>
    allLocations.DeliverLocations.find(
      (val) => val.DeliverLocationId === selectedLocationId
    );

  return (
    <>
      <motion.div
        className="map-backdrop"
        key="map-backdrop"
        initial={{ top: "0" }}
        animate={{ top: "100%" }}
        transition={{ duration: 0.5, delay: 7 }}
      >
        <MapLogo />
      </motion.div>
      <div className="upper-container location-container">
        {!selectedLocationId ? (
          allLocations.length !== 0 && (
            <LocationList data={allLocations} onSelect={handleSelect} />
          )
        ) : (
          <ConfirmLocation
            selectedLocation={getSelectedLocation}
            onErase={handleErase}
          />
        )}

        <div className="location-map">
          {allLocations.length !== 0 && showMap && (
            <Map data={allLocations} selectedId={selectedLocationId} />
          )}
        </div>
      </div>
    </>
  );
}
